import React from "react";

import { Box, Grid } from "@mui/material";
import { Typography } from "@mui/material";
import {
  AGB,
  imprintEmailAdress,
  linkedInProfileUrl,
  loginUrl,
  privacyPolicyRoute,
} from "common/constants/apiUrls";

const Imprint = () => {
  return (
    <div className="ds">
      <Grid container className="digital-solution-page-b ">
        <Grid item sm={6} xs={6} className="padded-container6 left-align padding-left-col">
          <Box component="div" className="simple-box">
            <Typography variant="h3" className="heading ">
              Impressum
            </Typography>

            <Typography variant="subtitle2" className="info-text ">
              1. Angaben gemäß § 5 des Telemediengesetzes
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Name des Anbieters:
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Volksbank Digital Solutions GmbH
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Rechtsform, Registrierung, Sitz:
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Die Volksbank Digital Solutions GmbH ist eine Gesellschaft mit beschränkter Haftung
              nach Maßgabe des GmbH-Gesetzes mit Sitz in Karlsruhe, eingetragen im Handelsregister
              des Amtsgerichts Mannheim unter der Nummer HRB 743371
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Umsatzsteuer-Identifikationsnummer (§ 27a des Umsatzsteuergesetzes):
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              DE 351463775
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Vertretungsberechtigte:
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Geschäftsführer Andreas Lorenz und Stefan Spohrer
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Postanschrift:
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Volksbank Digital Solutions GmbH, Ludwig-Erhard-Allee 1, 76131 Karlsruhe
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Kontaktdaten:
            </Typography>

            <Typography variant="subtitle2" className="info-text ">
              E-Mail: <a href={"mailto: " + imprintEmailAdress + ""}>{imprintEmailAdress}</a>
            </Typography>

            <Typography variant="subtitle2" className="info-text ">
              Internetseite:{" "}
              <a target="_blank" href={"https://" + loginUrl}>
                {loginUrl}
              </a>
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              2. Information gemäß § 2 Dienstleistungs-Informationsverordnung:
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Für von uns erbrachte Leistungen gelten unsere AGB. Sie finden sie unter{" "}
              <a target="_blank" href={"https://" + loginUrl + AGB}>
                {loginUrl + AGB}
              </a>
              . Darin ist geregelt, dass deutsches Recht Anwendung findet und dass, soweit zulässig,
              als Gerichtsstand Karlsruhe vereinbart wird.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              3. Haftung
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Wir sind für die Inhalte unserer Internetseiten nach den Maßgaben der allgemeinen
              Gesetzen, insbesondere nach § 7 Abs. 1 des Telemediengesetzes, verantwortlich. Alle
              Inhalte werden mit der gebotenen Sorgfalt und nach bestem Wissen erstellt. Soweit wir
              auf unseren Internetseiten mittels Hyperlink auf Internetseiten Dritter verweisen,
              können wir keine Gewähr für die fortwährende Aktualität, Richtigkeit und
              Vollständigkeit der verlinkten Inhalte übernehmen, da diese Inhalte außerhalb unseres
              Verantwortungsbereichs liegen und wir auf die zukünftige Gestaltung keinen Einfluss
              haben. Sollten aus Ihrer Sicht Inhalte gegen geltendes Recht verstoßen oder
              unangemessen sein, teilen Sie uns dies bitte mit.
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Die rechtlichen Hinweise auf dieser Seite sowie alle Fragen und Streitigkeiten im
              Zusammenhang mit der Gestaltung dieser Internetseite unterliegen dem Recht der
              Bundesrepublik Deutschland.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              4. Datenschutz
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Unsere Datenschutzhinweise finden Sie unter
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              <a target="_blank" href={"https://" + loginUrl + privacyPolicyRoute}>
                {loginUrl + privacyPolicyRoute}
              </a>
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              5. Urheberrechtshinweis
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Die auf unserer Internetseite vorhandenen Texte, Bilder, Fotos, Videos oder Grafiken
              unterliegen in der Regel dem Schutz des Urheberrechts. Jede unberechtigte Verwendung
              (insbesondere die Vervielfältigung, Bearbeitung oder Verbreitung) dieser
              urheberrechtsgeschützten Inhalte ist daher untersagt. Wenn Sie beabsichtigen, diese
              Inhalte oder Teile davon zu verwenden, kontaktieren Sie uns bitte im Voraus unter den
              oben stehenden Angaben. Soweit wir nicht selbst Inhaber der benötigten
              urheberrechtlichen Nutzungsrechte sein sollten, bemühen wir uns, einen Kontakt zum
              Berechtigten zu vermitteln.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              6. Social Media-Profile
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Dieses Impressum gilt auch für folgende Social Media-Profile:
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              LinkedIN:{" "}
              <a target="_blank" href={linkedInProfileUrl}>
                {linkedInProfileUrl}
              </a>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Imprint;
